/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Maxim Fedorov
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { icons } from '../../../../assets';
import { colors, fonts } from '../../../../theme';
import { FlexStyled } from '../../Block/Flexbox';

const CalendarSelectorContainerStyled = styled(FlexStyled)`
    width: 100%;
    align-items: flex-start;
    text-align: left !important;
    ${fonts.textSmall};
`;

const SelectArrowStyled = styled.div`
    width: 47px;
    height: 32px;
    object-fit: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
`;

interface ISelectArrowLeftStyled {
    isDisabled: boolean;
}

const SelectArrowLeftStyled = styled(SelectArrowStyled)<ISelectArrowLeftStyled>`
    margin-right: 8px;
    background-image: url(${icons.arrowLeftIcon});
    ${(props: ISelectArrowLeftStyled) =>
    `opacity: ${props.isDisabled ? '1' : '0.2'}`};
`;

const SelectArrowRightStyled = styled(SelectArrowStyled)`
    margin-left: 8px;
    background-image: url(${icons.arrowRightIcon});
`;

const SelectContainerStyled = styled.div.attrs({
    className: 'range-date-picker__calendar-title-wrapper',
})`
    width: 100%;
    & .select {
        min-width: auto !important;
    }
    
    .select-container {
        border-color: ${colors.borderColorLight};  
    } 
    .select_select-opened .select-container {
        border-color: ${colors.borderColorNormal};
    }    
`;

export {
    CalendarSelectorContainerStyled,
    SelectArrowStyled,
    SelectArrowLeftStyled,
    SelectArrowRightStyled,
    SelectContainerStyled,
};
